import { Suspense, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import LoadingSpinner from '@/components/LoadingSpinner'

// Lazy load components
const Ceramic = lazy(async () => import('@/pages/getRecipe/gingiva/ceramic'))
const Staining = lazy(async () => import('@/pages/getRecipe/gingiva/staining'))

const GingivaRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="ceramic" element={<Ceramic />} />
        <Route path="staining" element={<Staining />} />
        <Route path="" element={<Navigate to="staining" replace={true} />} />
      </Routes>
    </Suspense>
  )
}

export default GingivaRoutes
